<template>
  <VCard :color="ColorType.white" class="delivery-wrapper">
    <PreOrderDelivery
      :isProvideDeliveryReservation="isProvideDeliveryReservation"
      :delivery="delivery"
      :deliveryDetailAddress="deliveryDetailAddress"
      :deliveryPhoneNumber="deliveryPhoneNumber"
      :userEmail="userEmail"
      :isSign="isSign"
      :onChangeDelivery="changeDelivery"
      :onCheckedUseSafePhoneNumber="openSafePhoneNumberAlertModal"
      :onSafePhoneNumberInformation="openSafePhoneNumberInformationModal"
      :onChangeUserEmail="changeUserEmail"
    />
    <PreOrderDeliveryReservation
      v-if="isProvideDeliveryReservation"
      :deliveryReservation="deliveryReservation"
      :availableDeliveryReservation="availableDeliveryReservation"
      :onChangeDeliveryReservation="changeDeliveryReservation"
      :onDeliveryReservation="openDeliveryReservationModal"
    />
  </VCard>
</template>

<script>
import VCard, { ColorType } from '@/presentationals/v2/components/layouts/molecules/VCard'

import PreOrderDelivery from '../../layouts/organisms/PreOrderDelivery'
import PreOrderDeliveryReservation from '../../layouts/organisms/PreOrderDeliveryReservation'
import { notValidPattern } from '../../../../../models/PreOrder/OrderRequest'
import { isProvideDeliveryReservation } from '../../../../../config/featureProvider'

import { LogScreenName, LogType, LogGroup, LogEvent } from '@/plugins/AppLogManager'

export default {
  name: 'PreOrderDeliveryContainer',
  components: { PreOrderDeliveryReservation, PreOrderDelivery, VCard },
  computed: {
    delivery() {
      return this.$store.getters['preOrder/delivery']
    },
    deliveryDetailAddress() {
      return this.$store.getters['preOrder/delivery'].detailAddress
    },
    deliveryPhoneNumber() {
      return this.$store.getters['preOrder/delivery'].phoneNumber
    },
    deliveryReservation() {
      return this.$store.getters['preOrder/deliveryReservation']
    },
    availableDeliveryReservation() {
      return this.$store.getters['preOrder/availableDeliveryReservation']
    },
    includeReturnOrExchangeProduct() {
      return this.$store.getters['preOrder/includeReturnOrExchangeProduct']
    },
    userEmail() {
      return this.$store.getters.userEmail || ''
    },
    isSign() {
      return this.$store.getters.isSign
    },
    isProvideDeliveryReservation() {
      const { appVersion, isAndroid } = this.$store.getters

      return isProvideDeliveryReservation({
        appVersion,
        isAndroid,
        includeReturnOrExchangeProduct: this.includeReturnOrExchangeProduct
      })
    }
  },
  methods: {
    changeDelivery(delivery) {
      const { detailAddress } = delivery

      if (detailAddress !== undefined) {
        if (notValidPattern.test(detailAddress)) {
          const replacedDetailAddress = detailAddress.replace(notValidPattern, '')

          this.$store.commit('preOrder/setDelivery', { detailAddress: replacedDetailAddress })

          this.$store.dispatch('toast/open', {
            text: '특수문자는 ;:,.?!-_()*%# 만 입력 가능합니다.'
          })

          return
        }
      }

      this.$store.commit('preOrder/setDelivery', delivery)
    },
    changeDeliveryReservation(deliveryReservation) {
      this.$store.commit('preOrder/setDeliveryReservation', deliveryReservation)
    },
    changeUserEmail(userEmail) {
      this.$store.commit('setUserEmail', userEmail)
    },
    openSafePhoneNumberAlertModal() {
      this.$store.dispatch('modal/open', {
        type: 'Check',
        message: 'B마트는 안심번호 사용이 필수입니다.',
        params: {},
        onOK: async () => {
          this.$store.dispatch('modal/close')
        },
        onCancel: async () => {}
      })
    },
    openSafePhoneNumberInformationModal() {
      this.$store.dispatch('modal/open', {
        type: 'Check',
        title: '안심번호란?',
        message:
          '안심번호는 고객님의 개인정보를 보호하기 위해 실제 전화번호 대신 가상의 번호로 전화를 받을 수 있는 기능입니다. 전화를 받을 때만 유효하며, 가게나 라이더에게 전화를 거실 때에는 고객님의 실제 번호가 노출되니 주의해주세요.',
        params: {},
        onOK: async () => {
          this.$store.dispatch('modal/close')
        },
        onCancel: async () => {}
      })
    },

    openDeliveryReservationModalLog() {
      const params = {
        OrdNo: this.$store.getters['preOrder/orderSheetKey'],
        ShopNo: this.$store.getters['baeminShopNo']
      }

      // M2-2
      this.$appLogManager.post({
        screenName: LogScreenName.ORD,
        type: LogType.CLICK,
        group: LogGroup.ORD,
        event: LogEvent.RESERVATION,
        params
      })

    },

    selectedDeliveryReservationLog() {
      const params = {
        OrdNo: this.$store.getters['preOrder/orderSheetKey'],
        ShopNo: this.$store.getters['baeminShopNo']
      }

      // M2-3
      this.$appLogManager.post({
        screenName: LogScreenName.ORD,
        type: LogType.CLICK,
        group: LogGroup.ORD,
        event: LogEvent.TIME_SET,
        params
      })
    },

    openDeliveryReservationModal() {
      this.openDeliveryReservationModalLog()
      // TODO implement
      this.$store.dispatch('modal/open', {
        type: 'DeliveryReservation',
        message: '예약 배달 시간 설정',
        renderType: 'full-slide-up',
        params: {
          deliveryReservation: this.deliveryReservation,
          onDeliveryReservation: this.changeDeliveryReservation
        },
        onOK: async () => {
          this.selectedDeliveryReservationLog()
          this.$store.dispatch('modal/close')
        },
        onCancel: async () => {
          if (_.isEmpty(this.deliveryReservation.selected)) {
            this.changeDeliveryReservation({ use: false })
          }
          this.$store.dispatch('modal/close')
        }
      })
    }
  },
  data() {
    return {
      ColorType
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.delivery-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  border-bottom: 1px solid $light-gray-5;
}
</style>
